module.exports = __webpack_public_path__ + "img/cyberviz-6.33d0372b.png";